import type { SVGProps } from 'react';
import * as React from 'react';

const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m5 9 7 7 7-7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgChevronDown;
